/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShowActivity200ResponseDataCar
 */
export interface ShowActivity200ResponseDataCar {
    /**
     * 
     * @type {number}
     * @memberof ShowActivity200ResponseDataCar
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowActivity200ResponseDataCar
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowActivity200ResponseDataCar
     */
    garageId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataCar
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataCar
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataCar
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataCar
     */
    intro?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataCar
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataCar
     */
    make?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataCar
     */
    model?: string;
    /**
     * 
     * @type {number}
     * @memberof ShowActivity200ResponseDataCar
     */
    year?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowActivity200ResponseDataCar
     */
    photoUrls?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ShowActivity200ResponseDataCar
     */
    isPublic?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShowActivity200ResponseDataCar
     */
    ratingAverage?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowActivity200ResponseDataCar
     */
    ratingCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataCar
     */
    myRating?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataCar
     */
    myContributionStatus?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShowActivity200ResponseDataCar
     */
    canContribute?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataCar
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataCar
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ShowActivity200ResponseDataCar interface.
 */
export function instanceOfShowActivity200ResponseDataCar(value: object): value is ShowActivity200ResponseDataCar {
    return true;
}

export function ShowActivity200ResponseDataCarFromJSON(json: any): ShowActivity200ResponseDataCar {
    return ShowActivity200ResponseDataCarFromJSONTyped(json, false);
}

export function ShowActivity200ResponseDataCarFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowActivity200ResponseDataCar {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'garageId': json['garage_id'] == null ? undefined : json['garage_id'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'intro': json['intro'] == null ? undefined : json['intro'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'make': json['make'] == null ? undefined : json['make'],
        'model': json['model'] == null ? undefined : json['model'],
        'year': json['year'] == null ? undefined : json['year'],
        'photoUrls': json['photo_urls'] == null ? undefined : json['photo_urls'],
        'isPublic': json['is_public'] == null ? undefined : json['is_public'],
        'ratingAverage': json['rating_average'] == null ? undefined : json['rating_average'],
        'ratingCount': json['rating_count'] == null ? undefined : json['rating_count'],
        'myRating': json['my_rating'] == null ? undefined : json['my_rating'],
        'myContributionStatus': json['my_contribution_status'] == null ? undefined : json['my_contribution_status'],
        'canContribute': json['can_contribute'] == null ? undefined : json['can_contribute'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ShowActivity200ResponseDataCarToJSON(json: any): ShowActivity200ResponseDataCar {
    return ShowActivity200ResponseDataCarToJSONTyped(json, false);
}

export function ShowActivity200ResponseDataCarToJSONTyped(value?: ShowActivity200ResponseDataCar | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['userId'],
        'garage_id': value['garageId'],
        'nickname': value['nickname'],
        'display_name': value['displayName'],
        'slug': value['slug'],
        'intro': value['intro'],
        'summary': value['summary'],
        'make': value['make'],
        'model': value['model'],
        'year': value['year'],
        'photo_urls': value['photoUrls'],
        'is_public': value['isPublic'],
        'rating_average': value['ratingAverage'],
        'rating_count': value['ratingCount'],
        'my_rating': value['myRating'],
        'my_contribution_status': value['myContributionStatus'],
        'can_contribute': value['canContribute'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

